<template>
  <div id="totalBox">
    <div class="incomeBox">
      <p class="incomeTitle">收益才是目的</p>
      <div class="line"></div>
      <div class="incomeContentBox">
        <div class="incomeList">
          <img src="../../assets/ck/income.png" class="incomeImg"/>
          <p class="incomeListTitle">二大现金分红</p>
          <p class="incomeContent">车位共享分成</p>
          <p class="incomeContent">公司股权分红</p>
        </div>
        <div class="incomeList">
          <img src="../../assets/ck/amount.png" class="incomeImg"/>
          <p class="incomeListTitle">三大增值福利</p>
          <p class="incomeContent">免费海外旅游</p>
          <p class="incomeContent">助力成长基金</p>
          <p class="incomeContent">赠送巨额保险</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Income',
  data: function () {
    return {
      msg: '1'
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
  height: 590px;
  background-color: rgba(255,255,255,1);
}
.incomeBox{
  width: 1200px;
  height: 590px;
  margin: 0 auto;
  padding-top: 40px;
}
.incomeTitle{
  font-size:40px;
  font-weight:bold;
  color:rgba(35,24,21,1);
  line-height:28px;
}
.line{
  margin: 0 auto;
  margin-top: 20px;
  width:80px;
  height:4px;
  background:rgba(35,24,21,1);
}
.incomeContentBox{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 64px;
}
.incomeList{
  width: 600px;
  text-align: center;
}
.incomeImg{
  width: 200px;
  height: 200px;
}
.incomeListTitle{
  font-size:32px;
  font-weight:bold;
  color:rgba(33,33,33,1);
  margin-top: 30px;
}
.incomeContent{
  font-size:20px;
  font-weight:400;
  color:rgba(35,24,21,1);
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/ck/income.vue